export const getRgba = (color) => {
	if (!color?.rgb) return null;

	const { r, g, b, a } = color.rgb;
	return `rgba(${r}, ${g}, ${b}, ${a})`;
};